import type { AccountPersonalInformationQuery } from 'src/api';
import { AddressFieldsFormFields } from 'src/constants/address';

import { PersonalInformationFormFields, PersonalInformationFormValues } from '../types';

export const getAccountPersonalInformationInitialValues = (
  accountPersonalInformation: AccountPersonalInformationQuery['user'],
): PersonalInformationFormValues => {
  const homeAddress = accountPersonalInformation?.address;

  return {
    [PersonalInformationFormFields.firstName]: accountPersonalInformation?.firstName,
    [PersonalInformationFormFields.lastName]: accountPersonalInformation?.lastName,
    [PersonalInformationFormFields.email]: accountPersonalInformation?.email,
    [PersonalInformationFormFields.timezone]: accountPersonalInformation?.timezone,
    [PersonalInformationFormFields.birthDate]: accountPersonalInformation?.birthDate,
    [PersonalInformationFormFields.workEmail]: accountPersonalInformation?.employee?.workEmail,
    [PersonalInformationFormFields.title]: accountPersonalInformation?.title,
    [PersonalInformationFormFields.phoneNumber]: accountPersonalInformation?.phoneNumber,
    [PersonalInformationFormFields.homeAddress]: {
      [AddressFieldsFormFields.street]: homeAddress?.street,
      [AddressFieldsFormFields.city]: homeAddress?.city,
      [AddressFieldsFormFields.state]: homeAddress?.state,
      [AddressFieldsFormFields.county]: homeAddress?.county,
      [AddressFieldsFormFields.zipCode]: homeAddress?.zipCode,
    },
  };
};
